import {DocumentPart, PartType} from '@dv5/domain/document/model'

const untitledLabels: Record<PartType, string> = {
    [PartType.MARKDOWN]: 'markdown',
    [PartType.PLAINTEXT]: 'text',
    [PartType.CSV_TABLE]: 'table',
    [PartType.DIARY]: 'diary',
    [PartType.SECRET]: 'secret',
}

export const getOutlineLabel = (part: DocumentPart, index: number): string =>
    part.partHeader?.trim() || `Untitled ${untitledLabels[part.partType] || 'part'} · Part ${index + 1}`

// Tops and viewportTop are in the same (visual viewport) coordinate system.
export const getActiveOutlinePart = (
    parts: Array<{id: string; top: number}>, viewportTop: number, atBottom: boolean,
): string | null => {
    if (!parts.length) return null
    if (atBottom) return parts[parts.length - 1].id
    let active = parts[0].id
    for (const part of parts) {
        if (part.top > viewportTop + 1) break
        active = part.id
    }
    return active
}

export const getPartScrollTop = (
    scrollTop: number, partTop: number, viewportTop: number, scale: number,
): number => Math.max(0, scrollTop + (partTop - viewportTop) / scale)
